// extracted by mini-css-extract-plugin
export default {"text":"CeremonyCreateSuccessModal_text__6S0S0"};